import { render, staticRenderFns } from "./pushRuleForm.vue?vue&type=template&id=47a42bcd&scoped=true"
import script from "./pushRuleForm.vue?vue&type=script&lang=js"
export * from "./pushRuleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a42bcd",
  null
  
)

export default component.exports